/** Phases of the Standalone Mira -> My eXp Assistant migration experience. */
export type MiraMigrationPhase = 'none' | 'redirect';

export interface MiraMigrationPhaseResult {
  phase: MiraMigrationPhase;
  redirectUrl: string;
}

/**
 * Resolves the current Standalone Mira -> My eXp Assistant migration phase.
 * Gated purely on whether a destination URL is configured — there's no
 * feature-toggle involved. My eXp Assistant has its own feature-toggle
 * rollout mechanism, but that isn't implemented on the Mira/agent-platform
 * side yet, so this ships as a plain env-variable switch: configure
 * `REACT_APP_MYEXP_MIRA_URL` to turn the redirect on, leave it empty to
 * turn it off.
 */
export function resolveMiraMigrationPhase(
  redirectUrl: string,
): MiraMigrationPhase {
  return redirectUrl.trim() ? 'redirect' : 'none';
}

/**
 * Resolves the current Standalone Mira -> My eXp Assistant migration phase
 * and destination URL, both driven by `REACT_APP_MYEXP_MIRA_URL` — this
 * app's env vars are already the per-environment config mechanism for URLs
 * like `REACT_APP_ORCHESTRATOR_API_URL`, so this follows the same pattern.
 * The URL is used as configured; any `miraOpen=1` param is added on the
 * config side, not here.
 */
export function useMiraMigrationPhase(): MiraMigrationPhaseResult {
  const redirectUrl = process.env.REACT_APP_MYEXP_MIRA_URL ?? '';
  const phase = resolveMiraMigrationPhase(redirectUrl);

  return { phase, redirectUrl };
}
